<template>
  <Layout>
    <template #header-container>
      <PageHeader class="mc-page-three" :title="title" isSticky />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex float-end mt-2">
          <McButton
            variant="secondary"
            class="me-2"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
            @click="goBack"
          />
          <McButton
            v-if="!isAdding"
            variant="secondary"
            icon="icon-outline_paper-plane"
            class="me-2"
            :text="$t('dashboard.scheduler.action.sentNow')"
            @click="handleSentNow"
          />
          <McButton
            v-if="!isAdding"
            variant="secondary"
            class="me-2"
            :text="
              isActive
                ? $t('dashboard.scheduler.action.nonActive')
                : $t('dashboard.scheduler.action.active')
            "
            @click="$bvModal.show('modal-non-active')"
          />
          <McButton
            v-if="!isAdding"
            variant="secondary-red"
            icon="icon-outline_trash"
            class="me-2"
            :text="$t('global.delete')"
            @click="$bvModal.show('modal-delete')"
          />
          <McButton icon="icon-outline_save" :text="$t('global.save')" @click="submitData" />
        </div>
      </div>
    </template>
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <LoadingSkeleton />
      </template>
      <b-row>
        <b-col md="9">
          <FormulateForm ref="formRef" v-model="form">
            <b-card class="mt-4 border">
              <b-row>
                <b-col md="4">
                  <div class="my-2">
                    <FormulateInput
                      :placeholder="$t('report.title.scheduleName')"
                      validation-behavior="submit"
                      error-behavior="submit"
                      validation="required"
                      name="scheduleName"
                      type="text"
                      :disabled="isDisable"
                    >
                      <template #label>
                        <div class="d-flex justify-content-between align-items-center">
                          <label>
                            {{ $t('report.title.scheduleName') }} <i class="text-danger">*</i>
                          </label>
                        </div>
                      </template>
                    </FormulateInput>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <hr />
                </b-col>
                <b-col sm="12">
                  <div class="my-2">
                    <h5>{{ $t('dashboard.scheduler.form.deliverySchedule') }}</h5>
                  </div>
                </b-col>
                <b-col md="9">
                  <b-row class="my-2">
                    <b-col md="3" class="d-flex align-self-center">
                      <McRadioButton
                        id="hour"
                        key="hour"
                        v-model="form.period"
                        name="delivery_schedule"
                        initialValue="d"
                        :disabled="isDisable"
                        @input="handlePeriodChange"
                      >
                        <template #label>
                          <span>
                            <strong>{{ $t('dashboard.scheduler.selectTime.everyDay') }}</strong>
                            {{ $t('dashboard.scheduler.selectTime.atTime') }}
                          </span>
                        </template>
                      </McRadioButton>
                    </b-col>
                    <b-col md="4">
                      <date-picker
                        v-model="form.time"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        placeholder="HH:mm"
                        :disabled="form.period !== 'd'"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col md="3" class="d-flex align-self-center">
                      <McRadioButton
                        id="day"
                        key="day"
                        v-model="form.period"
                        name="delivery_schedule"
                        initialValue="w"
                        :disabled="isDisable"
                        @input="handlePeriodChange"
                      >
                        <template #label>
                          <span>
                            <strong>{{ $t('dashboard.scheduler.selectTime.everyWeek') }}</strong>
                            {{ $t('dashboard.scheduler.selectTime.atDay') }}
                          </span>
                        </template>
                      </McRadioButton>
                    </b-col>
                    <b-col md="4">
                      <multiselect
                        id="period"
                        v-model="form.noOfDay"
                        :options="dayOptions"
                        track-by="value"
                        label="text"
                        :placeholder="$t('report.action.selectDate')"
                        openDirection="bottom"
                        :disabled="form.period !== 'w'"
                      />
                    </b-col>
                    <b-col md="1" class="d-flex align-self-center">
                      <div class="float-end">
                        {{ $t('global.time.hours') }}
                      </div>
                    </b-col>
                    <b-col md="4">
                      <date-picker
                        v-model="form.time"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        placeholder="HH:mm"
                        :disabled="form.period !== 'w'"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="my-2">
                    <b-col md="3" class="d-flex align-self-center">
                      <McRadioButton
                        id="date"
                        key="date"
                        v-model="form.period"
                        name="delivery_schedule"
                        initialValue="m"
                        :disabled="isDisable"
                        @input="handlePeriodChange"
                      >
                        <template #label>
                          <span>
                            <strong>{{ $t('dashboard.scheduler.selectTime.everyMonth') }}</strong>
                            {{ $t('dashboard.scheduler.selectTime.atDate') }}
                          </span>
                        </template>
                      </McRadioButton>
                    </b-col>
                    <b-col md="4">
                      <multiselect
                        id="period"
                        v-model="form.noOfDate"
                        :options="dateOptions"
                        track-by="value"
                        label="text"
                        :placeholder="$t('global.action.selectDate')"
                        openDirection="bottom"
                        :disabled="form.period !== 'm'"
                      />
                    </b-col>
                    <b-col md="1" class="d-flex align-self-center">
                      <div class="float-end">
                        {{ $t('global.time.hours') }}
                      </div>
                    </b-col>
                    <b-col md="4">
                      <date-picker
                        v-model="form.time"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        placeholder="HH:mm"
                        :disabled="form.period !== 'm'"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12">
                  <div class="my-2">
                    <h5>{{ $t('dashboard.scheduler.form.deliveryPeriod') }}</h5>
                  </div>
                </b-col>
                <b-col sm="12" md="9">
                  <b-row md="12" class="my-2">
                    <b-col md="9" sm="12" xl="4">
                      <FormulateInput
                        validation-behavior="submit"
                        error-behavior="submit"
                        validation="required"
                        name="startDate"
                        type="date-picker"
                        :disabled="isDisable"
                        :placeholder="$t('global.action.selectDate')"
                        format="DD MMM YYYY"
                        value-type="YYYY-MM-DD"
                        :confirm="true"
                        :confirm-text="$t('global.action.apply')"
                        :clearable="false"
                        :lang="datePickerLang"
                      >
                        <template #label>
                          <div class="d-flex justify-content-between align-items-center">
                            <label>
                              {{ $t('dashboard.scheduler.form.startDate') }}
                              <i class="text-danger">*</i>
                            </label>
                          </div>
                        </template>
                      </FormulateInput>
                    </b-col>
                    <b-col md="9" sm="12" xl="1">
                      <div class="d-flex justify-content-center align-self-center">-</div>
                    </b-col>
                    <b-col md="9" sm="12" xl="4">
                      <FormulateInput
                        name="endDate"
                        type="date-picker"
                        :disabled="isDisable"
                        :placeholder="$t('global.action.selectDate')"
                        format="DD MMM YYYY"
                        value-type="YYYY-MM-DD"
                        :confirm="true"
                        :confirm-text="$t('global.action.apply')"
                        :clearable="false"
                        :lang="datePickerLang"
                      >
                        <template #label>
                          <div class="d-flex justify-content-between align-items-center">
                            <label>{{ $t('dashboard.scheduler.form.endDate') }}</label>
                          </div>
                        </template>
                      </FormulateInput>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="8">
                  <hr />
                </b-col>
              </b-row>
              <b-row class="mx-1">
                <b-alert show variant="primary" class="mc-alert">
                  <i class="mc-fa icon-fill_info"></i>
                  {{
                    form.period === 'm'
                      ? $t('dashboard.scheduler.text.sendEverydate', {
                          date: ` ${form.noOfDate?.text} `,
                          time: form.time,
                        })
                      : form.period === 'w'
                      ? $t('dashboard.scheduler.text.sendEveryday', {
                          day:
                            form.period === 'd'
                              ? ' '
                              : form.noOfDay?.text
                              ? ` ${form.noOfDay?.text} `
                              : ' ',
                          time: form.time,
                        })
                      : $t('dashboard.scheduler.text.sendEveryday', {
                          day:
                            form.period === 'd'
                              ? ' '
                              : form.noOfDay?.text
                              ? ` ${form.noOfDay?.text} `
                              : ' ',
                          time: form.time,
                        })
                  }}
                  {{
                    $t('dashboard.scheduler.text.startingFrom', {
                      date: momentDateLongMonth(form.startDate),
                    })
                  }}
                </b-alert>
              </b-row>
            </b-card>

            <b-card v-if="showContentSection">
              <h5 class="mb-4">
                {{ $t('dashboard.deliverSummary.summaryContent') }}
              </h5>

              <div
                v-for="content in contentLists"
                :id="content.content_id"
                :key="content.content_id"
                role="button"
                type="button"
                :class="`mc-summary-content${
                  contentList == content.content_id ? '--selected' : ''
                }`"
                @click="handleContentValue(content)"
              >
                <McRadioButton
                  :id="content.content_id"
                  :key="content.content_id"
                  v-model="contentList"
                  name="content_list"
                  :label="content.content_name"
                  :initialValue="content.content_id"
                  @input="handleContentValue(content)"
                />
              </div>
            </b-card>

            <b-card class="border">
              <Recipient :isAdding="isAdding" />
              <b-alert show variant="primary" class="mt-4 mc-alert">
                <div class="d-flex align-items-center">
                  <i class="mc-fa icon-fill_info"></i>
                  <ul v-if="form.period == 'd'" class="mb-0">
                    <li>
                      <span
                        v-html="sanitizeHTML($t('dashboard.scheduler.alert.dailyDigestbyWA'))"
                      />
                      <a
                        href="https://kb.mceasy.com/docs/new-mceasy-whatsapp-service/"
                        class="text-primary text-decoration-underline"
                        target="_blank"
                      >
                        {{ $t('maintenance.tooltip.learnMore') }}
                      </a>
                    </li>
                    <li>
                      {{ $t('dashboard.scheduler.alert.check') }}
                      <strong> {{ 'Spam / Junk Folders' }} </strong>,
                      {{ $t('dashboard.scheduler.alert.notReceive') }}
                    </li>
                  </ul>
                  <span v-else>
                    {{ $t('dashboard.scheduler.alert.check') }}
                    <strong> {{ 'Spam / Junk Folders' }} </strong>,
                    {{ $t('dashboard.scheduler.alert.notReceive') }}
                  </span>
                </div>
              </b-alert>
              <b-row>
                <b-col md="12" class="my-2">
                  <div>
                    <FormulateInput
                      :placeholder="$t('dashboard.scheduler.form.emailSubject')"
                      validation-behavior="submit"
                      error-behavior="submit"
                      validation="required:trim"
                      name="emailTitle"
                      :disabled="isDisable"
                      @input.native="hasChanged"
                    >
                      <template #label>
                        <label>
                          {{ $t('dashboard.scheduler.form.emailSubject') }}
                          <i class="text-danger">*</i>
                        </label>
                        <div class="float-end">
                          <span
                            v-b-tooltip.right
                            :title="$t('dashboard.scheduler.tooltip.emailTitle')"
                          >
                            <i class="icon-outline_info"></i>
                          </span>
                        </div>
                      </template>
                    </FormulateInput>
                  </div>
                </b-col>
                <b-col md="12" class="my-2">
                  <FormulateInput
                    type="textarea"
                    validation-behavior="submit"
                    error-behavior="submit"
                    validation="required:trim"
                    name="content"
                    :placeholder="$t('dashboard.scheduler.form.emailBody')"
                    :disabled="isDisable"
                    class="email-body"
                    @input.native="hasChanged"
                  >
                    <template #label>
                      <label>
                        {{ $t('dashboard.scheduler.form.emailBody') }} <i class="text-danger">*</i>
                      </label>
                      <div class="float-end">
                        <span
                          v-b-tooltip.right
                          :title="$t('dashboard.scheduler.tooltip.emailContent')"
                        >
                          <i class="icon-outline_info"></i>
                        </span>
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
              </b-row>
            </b-card>
          </FormulateForm>
        </b-col>
        <b-col md="3" class="mt-4 mc-scheduler-digest-preview">
          <DigestPreview
            v-if="!digestLoading"
            :title="form.emailTitle"
            :content="form.content"
            :period="form.period"
            :selected-content="contentList"
            :dataContent="dataContent"
            :loading="digestLoading"
          />
        </b-col>
      </b-row>
    </b-skeleton-wrapper>

    <b-modal
      id="modal-non-active"
      ref="modal-non-active"
      class="mc-modal"
      :title="
        isActive
          ? $t('dashboard.scheduler.text.nonActiveSchedule')
          : $t('dashboard.scheduler.text.activeSchedule')
      "
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('dashboard.scheduler.modal.changeStatus') }}
          <span class="fw-bold">{{ form.scheduleName }}</span>
          {{
            isActive
              ? $t('dashboard.scheduler.modal.nonActive')
              : $t('dashboard.scheduler.modal.active')
          }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.yes')" @click="handleStatusChange" />
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-delete"
      ref="modal-delete"
      class="mc-modal"
      :title="`${$t('global.delete')} Penjadwalan`"
      size="md"
      centered
    >
      <div class="card-body p-2">
        <p>
          {{ $t('dashboard.scheduler.modal.delete') }}
          <span class="fw-bold">{{ form.scheduleName }}</span>
          ?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.delete')" @click="handleDelete" />
        </div>
      </template>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import McButton from '@/components/McButton'
import LoadingSkeleton from './LoadingSkeleton'
import datePickerLang from '@/helpers/date-picker-lang'
import McRadioButton from '@/components/McRadioButton'
import Multiselect from 'vue-multiselect'
import Recipient from './TableRecipient'
import {
  GET_DETAIL_REPORT_SCHEDULER,
  CREATE_REPORT_SCHEDULER,
  UPDATE_REPORT_SCHEDULER,
  DELETE_REPORT_SCHEDULER,
} from '@/services/api/report/report'
import { SEND_REPORT_HTML } from '@/services/api/dashboard/scheduler'
import moment from 'moment'
import DigestPreview from './DigestPreview.vue'
import { getSummaryDigest } from '@/services/rest-api-identity/lib/metabase/custom'

moment.locale('id')

export default {
  page: {
    title: 'Kirim Rangkuman',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    LoadingSkeleton,
    DigestPreview,
    McRadioButton,
    Multiselect,
    Recipient,
  },
  mixins: [Helper, MixPanel],
  data() {
    const periodDefault = this.$t('global.time.monthly')

    const defaultContent = {
      content_id: '0',
      content_name: 'Rekapitulasi Operational',
      title: `Rangkuman Rekapitulasi Operational, ${periodDefault} ${this.$store.state.identity.whoami.companyName}`,
      content: `Berikut ini merupakan rangkuman ${periodDefault} Rekapitulasi Operational untuk ${this.$store.state.identity.whoami.companyName}`,
      category: ['monthly'],
    }

    return {
      isDisable: false,
      isLoading: false,
      isActive: true,
      defaultContent,
      form: {
        period: 'm',
        time: '10:00',
        noOfDay: { value: 0, text: this.$t('global.days.sunday') },
        noOfDate: { value: 1, text: '1' },
        recipients: [],
        emailTitle: defaultContent.title,
        content: defaultContent.content,
      },
      contentList: '0',
      preview: {
        content: '',
        widgetId: [],
      },
      isSubmit: false,
      hasCustom: false,
      contentLists: [defaultContent],
      dataContent: {},
      digestLoading: false,
      isManualPeriodChange: false,
      selectedContent: {},
    }
  },
  computed: {
    title() {
      return this.$t('dashboard.deliverSummary.title')
    },
    isAdding() {
      return this.$route.params.id === undefined
    },
    dayOptions() {
      return [
        { value: 0, text: this.$t('global.days.sunday') },
        { value: 1, text: this.$t('global.days.monday') },
        { value: 2, text: this.$t('global.days.tuesday') },
        { value: 3, text: this.$t('global.days.wednesday') },
        { value: 4, text: this.$t('global.days.thursday') },
        { value: 5, text: this.$t('global.days.friday') },
        { value: 6, text: this.$t('global.days.saturday') },
      ]
    },
    dateOptions() {
      let options = []
      for (let i = 1; i <= 31; i++) {
        let obj = {
          value: i,
          text: `${i}`,
        }
        options.push(obj)
      }
      return options
    },
    datePickerLang() {
      return datePickerLang()
    },

    showContentSection() {
      return this.contentLists.length > 1
    },
  },

  watch: {
    'form.period': {
      async handler(val) {
        await this.getSummaryDigest(val)
        if (this.isManualPeriodChange) {
          this.contentList = '0'
          this.isManualPeriodChange = false
        }

        this.resetValue()
      },
    },
    contentList: {
      async handler() {
        this.resetValue()
      },
    },
  },

  async mounted() {
    this.track('View Digest Settings')
    if (!this.isAdding) {
      await this.getData()
      await this.getSummaryDigest(this.form.period)
      this.dataContent = this.contentLists.filter((item) => item.content_id == this.contentList)[0]
    } else await this.getSummaryDigest(this.form.period)
  },

  methods: {
    hasChanged(e) {
      if (document.activeElement === e.target) {
        this.hasCustom = true
      }
    },
    resetValue() {
      if (this.contentList == '0') {
        this.selectedContent = {
          ...this.defaultContent,
          content_name: 'Rekapitulasi Operational',
          category: [this.getContentList(this.form.period)],
        }
        this.handleContentValue(this.selectedContent)
      }
    },
    handlePeriodChange() {
      this.isManualPeriodChange = true
    },
    getContentList(val) {
      switch (val) {
        case 'd':
          return 'daily'
        case 'w':
          return 'weekly'
        case 'm':
          return 'monthly'
      }
    },

    async getSummaryDigest(value) {
      const category = this.getContentList(value)
      const res = await getSummaryDigest(category)

      this.contentLists = [this.defaultContent]
      if (res?.data.length > 0) {
        const response = res?.data
        this.contentLists = [this.defaultContent, ...response]
      }
    },

    async getData() {
      this.isLoading = true
      await this.$apollo
        .query({
          query: GET_DETAIL_REPORT_SCHEDULER,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              id: Number(this.$route.params.id),
            },
          },
        })
        .then((res) => {
          if (!res.data.reportScheduler.isSuccessful) {
            this.$mcToast.error(res.data.reportScheduler.message)
            return false
          }
          const item = res.data.reportScheduler.reportScheduler

          this.isActive = item.isActive
          this.form = {
            emailTitle: item.title,
            content: item.body?.replace(/<br\/>/g, '\n'),
            time: moment(item.time, 'HH:mm:ss').format('HH:mm'),
            startDate: moment(item.startTime).format('YYYY-MM-DD'),
            endDate: moment(item.endTime).format('YYYY-MM-DD'),
            scheduleName: item.scheduleName,
            reportName: 'Email Digest',
            reportKey: 'email-digest',
            period: item.period,
            filter: JSON.parse(item.filter),
          }

          this.contentList =
            item?.reportSchedulerContent.length > 0 ? item.reportSchedulerContent[0].contentId : '0'

          if (item.noOfDay !== null) {
            if (item.period === 'w') {
              this.form.noOfDate = null
              this.form.noOfDay = this.dayOptions.find((option) => option.value === item.noOfDay)
            } else if (item.period === 'm') {
              this.form.noOfDay = null
              this.form.noOfDate = this.dateOptions.find((option) => option.value === item.noOfDay)
            }
          }
          setTimeout(() => {
            this.isLoading = false
          }, 1000)
        })
    },
    handleStatusChange() {
      const input = {
        isActive: !this.isActive,
      }
      this.updateData(this.$route.params.id, input)
    },
    validate() {
      if (this.$refs.formRef.hasErrors) {
        this.$refs.formRef.showErrors()
        return false
      }
      return true
    },
    async handleSentNow() {
      const res = await this.$apollo.mutate({
        mutation: SEND_REPORT_HTML,
        variables: {
          input: {
            reportSchedulerId: Number(this.$route.params.id),
          },
        },
      })
      if (res.data.sendReportHtml.isSuccessful) {
        this.$mcToast.success(this.$t('dashboard.scheduler.dashboardSent'))
      } else {
        this.$mcToast.error(res.data.sendReportHtml.message)
      }
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: DELETE_REPORT_SCHEDULER,
          variables: {
            input: {
              reportSchedulerIds: [Number(this.$route.params.id)],
            },
          },
        })
        .then((response) => {
          if (response.data.deleteReportScheduler.isSuccessful) {
            this.$mcToast.success(this.$t('global.alert.text.delete'))
            setTimeout(() => {
              this.$router.push({
                name: 'Dashboard Scheduler',
              })
            }, 500)
          } else {
            return this.$mcToast.error(response.data.deleteReportScheduler.message)
          }
        })
    },

    submitData() {
      let validate = this.validate()
      if (!validate) {
        this.isSubmit = false
        return
      }
      this.isSubmit = true

      const formattedContent = this.form.content?.replace(/\n/g, '<br/>')
      let noOfDay = null
      if (this.form.period === 'w') {
        noOfDay = this.form.noOfDay ? this.form.noOfDay.value : 0
      } else if (this.form.period === 'm') {
        noOfDay = this.form.noOfDate ? this.form.noOfDate.value : 1
      }

      const input = {
        title: this.form.emailTitle,
        body: formattedContent,
        time: moment(this.form.time, 'HH:mm').format('HH:mm:ss'),
        startTime: moment(this.form.startDate + ' 00:00:00.000').toISOString(),
        endTime: moment(this.form.endDate + ' 23:59:59.000').toISOString(),
        scheduleName: this.form.scheduleName,
        reportName: 'Email Digest',
        period: this.form.period,
        noOfDay: noOfDay,
        contents:
          this.contentList == '0'
            ? []
            : [
                {
                  id: this.contentList,
                  type: 'Metabase',
                },
              ],
      }

      if (this.isAdding) this.saveData(input)
      else this.updateData(this.$route.params.id, input)
    },

    handleContentValue(value) {
      this.digestLoading = true
      this.contentList = value.content_id
      this.dataContent = this.contentLists?.filter((item) => item.content_id == value.content_id)[0]
      this.selectedContent = value
      if (!this.hasCustom && this.isAdding) {
        if (this.contentList == '0') value.content_name = 'Rekapitulasi Operational'
        this.form.emailTitle = `Rangkuman ${value.content_name}, ${this.$t(
          `global.time.${value.category[0]}`
        )}, ${this.$store.state.identity.whoami.companyName}`
        this.form.content = `Berikut ini merupakan rangkuman ${this.$t(
          `global.time.${value.category[0]}`
        )} ${value.content_name} untuk ${this.$store.state.identity.whoami.companyName}`
      }

      this.digestLoading = false
    },

    saveData(input) {
      const contacts = this.$store.state.dashboard.contactList.map((item) => {
        return {
          label: item.label,
          userId: item.userId == 9999999 ? null : item.userId,
          phoneNumber: item.phoneNumber,
          email: item.email,
        }
      })
      const allInput = {
        ...input,
        contactRecipients: contacts,
      }

      this.$apollo
        .mutate({
          mutation: CREATE_REPORT_SCHEDULER,
          variables: {
            input: {
              ...allInput,
              reportKey: 'email-digest',
            },
          },
        })
        .then((response) => {
          if (response.data.createReportScheduler.isSuccessful) {
            this.$mcToast.success(this.$t('global.alert.text.added'))
            this.isLoading = true
            this.$router.push({
              name: 'Update Dashboard Scheduler',
              params: {
                id: response.data.createReportScheduler.reportScheduler.reportSchedulerId,
              },
            })

            setTimeout(() => {
              this.getData()
            }, 1000)
          } else {
            this.isSubmit = false
            return this.$mcToast.error(response.data.createReportScheduler.message)
          }
        })
    },
    updateData(id, input) {
      const update = {
        id: Number(id),
        ...input,
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_REPORT_SCHEDULER,
          variables: {
            input: update,
          },
        })
        .then((response) => {
          if (response.data.updateReportScheduler.isSuccessful) {
            this.$mcToast.success(this.$t('global.alert.text.changed'))
            setTimeout(() => {
              this.$router.push({
                name: 'Dashboard Scheduler',
              })
            }, 500)
          } else {
            this.isSubmit = false
            return this.$mcToast.error(response.data.updateReportScheduler.message)
          }
        })
    },
    goBack() {
      this.$store.commit('dashboard/RESET_CONTACT')
      this.$router.push({
        name: 'Dashboard Scheduler',
      })
    },
  },
}
</script>
